import { object, string, boolean } from 'yup';
import { StepTwoForm, ActiveFormVariant, LessonAssignmentState } from './types';
import { translate } from 'translations/translator';
import AssignmentVariant from 'translations/variants/lessonAssignment';
const translateValidation = (key: AssignmentVariant) => translate('lessonAssignment', key);

export const sectionTypes = ['warmup', 'practice', 'extras'];

export const stepOneValidationSchema = object({
  title: string().required(translateValidation(AssignmentVariant.titleIsRequired)),
  assigned: boolean().required(translateValidation(AssignmentVariant.eachAssignmentShouldActivity)),
  startDate: string().required(translateValidation(AssignmentVariant.assignmentStartDateRequired)),
  dueDate: string().required(translateValidation(AssignmentVariant.assignmentDueDateRequired))
  // instructions: string().required('instructions are required')
});

export const getDefaultStepOneFormState = () => ({
  instructions: '',
  audioFiles: []
});

export const getBlankLessonData = () => ({
  lesson: {
    sections: sectionTypes.map(type => ({
      title: translateValidation(AssignmentVariant[type]),
      type,
      activities: []
    }))
  }
});

export const getDefaultStepTwoFormState = (): StepTwoForm => ({
  classroomIds: [] as number[],
  studentIds: [] as number[]
});

export const getDefaultLessonAssignmentState = (): LessonAssignmentState => ({
  activeFormId: '',
  activeFormVariant: ActiveFormVariant.EDITABLE,
  isEditingTitle: false,
  lastActiveFormId: '',
  studentsAndClassrooms: [],
  dateRange: ''
});
